import React from 'react';

import PageWrapper from '@media-spec/core/src/containers/PageWrapper';
import {
  peopleList,
  defaultMetaTitle,
  defaultMetaDescription,
} from '@utils/staticText';

import { counterTriggerAll } from '@utils/counters';

import * as T from './Pages.types';
import { Footer } from '@components/Footer/Footer';
import MainLogo from '@images/header_logo.svg';
import mainImg from '@images/main_imgOg.jpg';

export const Pages: React.FunctionComponent<T.IPagesProps> = ({
  children,
  personId,
}) => {
  const helmetProps =
    typeof personId === 'number'
      ? {
          title: `${peopleList[personId].title} - ${defaultMetaTitle}`,
          ogTitle: `${peopleList[personId].title} - ${defaultMetaTitle}`,
          viewport: 'width=device-width,initial-scale=1',
          ogDecription: peopleList[personId].subTitle,
          description: peopleList[personId].subTitle,
          ogImage: peopleList[personId].bigAvatar,
          ogImageWidth: peopleList[personId].ogImageWidth,
          ogImageHeight: peopleList[personId].ogImageHeight,
        }
      : {
          title: defaultMetaTitle,
          ogTitle: defaultMetaTitle,
          viewport: 'width=device-width,initial-scale=1',
          ogDecription: defaultMetaDescription,
          description: defaultMetaDescription,
          ogImage: mainImg,
          ogImageWidth: 1200,
          ogImageHeight: 627,
        };
  React.useEffect(() => {
    // Предотвращаем двойной триггер счётчика при загрузке страницы
    // @ts-ignore
    if (window.enableToTrigger) {
      counterTriggerAll();
    } else {
      // @ts-ignore
      window.enableToTrigger = true;
    }
  }, []);

  return (
    <PageWrapper
      helmetProps={helmetProps}
      menuProps={{
        services: peopleList.map(({ title }, index) => ({
          title,
          href: `/person/${index}/`,
        })),
        share: false,
        burgerColor: '#005FF9',
        MainLogo,
      }}
    >
      {children}
      <Footer />
    </PageWrapper>
  );
};
